import {PSEUDO_CATEGORY} from '../../constants/infinite-list';
import {initInfiniteList} from '../../services/_infinite-list';

initInfiniteList(PSEUDO_CATEGORY);
